var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9275 0.0166016H9.37753C4.55172 0.0166016 0.602539 3.96361 0.602539 8.79065V26.3387C0.602539 31.164 4.55172 35.1128 9.37753 35.1128H26.9275C31.7533 35.1128 35.7025 31.164 35.7025 26.3387V8.79065C35.7025 3.96361 31.7533 0.0166016 26.9275 0.0166016ZM18.1525 24.876C14.1134 24.876 10.8398 21.6014 10.8398 17.5644C10.8398 13.5257 14.1134 10.2524 18.1525 10.2524C22.1899 10.2524 25.4651 13.5257 25.4651 17.5644C25.4651 21.6014 22.1899 24.876 18.1525 24.876ZM25.4648 8.05996C25.4648 9.27135 26.4459 10.2537 27.6586 10.2537C28.8713 10.2537 29.8523 9.27135 29.8523 8.05996C29.8523 6.84857 28.8713 5.86621 27.6586 5.86621C26.4459 5.86621 25.4648 6.84857 25.4648 8.05996Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.1482bea325e65edc1df775b90a9fb486.svg";
export { ForwardRef as ReactComponent };